import { usePackageCarsShopPage, usePackageCarsShopPageRoute } from "./hooks";
import { PackageCarsShopPage } from "./PackageCarsShopPage";

export const PackageCarsShopPageRoute = () => {
  const search = usePackageCarsShopPageRoute();
  const data = usePackageCarsShopPage({ search });

  return <PackageCarsShopPage {...data} />;
};
